import { render } from "./MfMinisiteHomeView.vue?vue&type=template&id=18ab7565&ts=true"
import script from "./MfMinisiteHomeView.vue?vue&type=script&lang=ts"
export * from "./MfMinisiteHomeView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__